import { LOCATION_CHANGE } from "connected-react-router";

const USER_MSG = "USER_MSG",
  GET_USERS_START = "GET_USERS_START",
  GET_USERS_SUCCESS = "GET_USERS_SUCCESS",
  LOGIN = "LOGIN",
  SYSTEM_OVERVIEW_START = "SYSTEM_OVERVIEW_START",
  SYSTEM_OVERVIEW_SUCCESS = "SYSTEM_OVERVIEW_SUCCESS",
  SESSION_START = "SESSION_START",
  SESSION_SUCCESS = "SESSION_SUCCESS",
  SCHEDULE_START = "SCHEDULE_START",
  SCHEDULE_SUCCESS = "SCHEDULE_SUCCESS",
  RX_START = "RX_START",
  RX_SUCCESS = "RX_SUCCESS",
  TX_START = "TX_START",
  TX_SUCCESS = "TX_SUCCESS",
  CONNECTION_START = "CONNECTION_START",
  CONNECTION_SUCCESS = "CONNECTION_SUCCESS",
  RXGROUP_START = "RXGROUP_START",
  RXGROUP_SUCCESS = "RXGROUP_SUCCESS",
  VW_START = "VW_START",
  VW_SUCCESS = "VW_SUCCESS",
  USERS_START = "USERS_START",
  USERS_SUCCESS = "USERS_SUCCESS",
  UGROUP_START = "UGROUP_START",
  UGROUP_SUCCESS = "UGROUP_SUCCESS",
  PERMISSIONINBATCH_START = "PERMISSIONINBATCH_START",
  PERMISSIONINBATCH_SUCCESS = "PERMISSIONINBATCH_SUCCESS",
  LOCATION_START = "LOCATION_START",
  LOCATION_SUCCESS = "LOCATION_SUCCESS",
  TGROUP_START = "TGROUP_START",
  TGROUP_SUCCESS = "TGROUP_SUCCESS",
  VIRTUALTX_START = "VIRTUALTX_START",
  VIRTUALTX_SUCCESS = "VIRTUALTX_SUCCESS",
  SETTINGGENERAL = "SETTINGGENERAL",
  SETTINGREDUNDANCY = "SETTINGREDUNDANCY",
  SETTINGANMS = "SETTINGANMS",
  PERMISSIONINBATCH_TX_START = "PERMISSIONINBATCH_TX_START",
  PERMISSIONINBATCH_TX_SUCCESS = "PERMISSIONINBATCH_TX_SUCCESS",
  PROFILELIST_START = "PROFILELIST_START",
  PROFILELIST_SUCCESS = "PROFILELIST_SUCCESS",
  SCHEDULELIST_START = "SCHEDULELIST_START",
  SCHEDULELIST_SUCCESS = "SCHEDULELIST_SUCCESS",
  SCENE_STORAGE = "SCENE_STORAGE",
  DEVICE_STATUS = "DEVICE_STATUS",
  PERMISSION_UGROUP_START = "PERMISSION_UGROUP_START",
  PERMISSION_UGROUP_SUCCESS = "PERMISSION_UGROUP_SUCCESS",
  PERMISSION_USER_START = "PERMISSION_USER_START",
  PERMISSION_USER_SUCCESS = "PERMISSION_USER_SUCCESS",
  SELECT_KE_PRODUCTS = "SELECT_KE_PRODUCTS",
  ERROR_HANDLE = "ERROR_HANDLE";
export {
  LOCATION_CHANGE,
  USER_MSG,
  GET_USERS_START,
  GET_USERS_SUCCESS,
  LOGIN,
  SYSTEM_OVERVIEW_START,
  SYSTEM_OVERVIEW_SUCCESS,
  SESSION_START,
  SESSION_SUCCESS,
  SCHEDULE_START,
  SCHEDULE_SUCCESS,
  RX_START,
  RX_SUCCESS,
  TX_START,
  TX_SUCCESS,
  CONNECTION_START,
  CONNECTION_SUCCESS,
  RXGROUP_START,
  RXGROUP_SUCCESS,
  VW_START,
  VW_SUCCESS,
  USERS_START,
  USERS_SUCCESS,
  UGROUP_START,
  UGROUP_SUCCESS,
  PERMISSIONINBATCH_START,
  PERMISSIONINBATCH_SUCCESS,
  LOCATION_START,
  LOCATION_SUCCESS,
  TGROUP_START,
  TGROUP_SUCCESS,
  VIRTUALTX_START,
  VIRTUALTX_SUCCESS,
  SETTINGGENERAL,
  SETTINGREDUNDANCY,
  SETTINGANMS,
  PERMISSIONINBATCH_TX_START,
  PERMISSIONINBATCH_TX_SUCCESS,
  PROFILELIST_START,
  PROFILELIST_SUCCESS,
  SCHEDULELIST_START,
  SCHEDULELIST_SUCCESS,
  SCENE_STORAGE,
  DEVICE_STATUS,
  PERMISSION_UGROUP_START,
  PERMISSION_UGROUP_SUCCESS,
  PERMISSION_USER_START,
  PERMISSION_USER_SUCCESS,
  SELECT_KE_PRODUCTS,
  ERROR_HANDLE,
};
